import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  isDomainSplitActive,
  isOnMarketingHost,
  isOnAppHost,
  belongsToApp,
  belongsToMarketing,
  appUrl,
  marketingUrl,
} from "@/lib/domains";

/**
 * Watches the current path and — only in the production two-domain
 * deployment — replaces the browser location if the route lives on the
 * OTHER host. In preview / single-origin deployments this is a no-op.
 *
 *   viyora.co.in/login          →  app.viyora.co.in/login
 *   viyora.co.in/app/dashboard  →  app.viyora.co.in/app/dashboard
 *   app.viyora.co.in/pricing    →  viyora.co.in/pricing
 *   app.viyora.co.in/legal/tos  →  viyora.co.in/legal/tos
 */
export default function DomainRouter() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isDomainSplitActive()) return;

    if (isOnMarketingHost() && belongsToApp(pathname)) {
      window.location.replace(appUrl(pathname + search + hash));
      return;
    }
    if (isOnAppHost() && belongsToMarketing(pathname)) {
      window.location.replace(marketingUrl(pathname + search + hash));
      return;
    }
  }, [pathname, search, hash]);

  return null;
}
